var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBillingDateIcon = function SvgBillingDateIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 2C6.54076 2 6.69973 2.06585 6.81694 2.18306C6.93415 2.30027 7 2.45924 7 2.625V3.25H17V2.625C17 2.45924 17.0658 2.30027 17.1831 2.18306C17.3003 2.06585 17.4592 2 17.625 2C17.7908 2 17.9497 2.06585 18.0669 2.18306C18.1842 2.30027 18.25 2.45924 18.25 2.625V3.25H19.5C20.163 3.25 20.7989 3.51339 21.2678 3.98223C21.7366 4.45107 22 5.08696 22 5.75V19.5C22 20.163 21.7366 20.7989 21.2678 21.2678C20.7989 21.7366 20.163 22 19.5 22H4.5C3.83696 22 3.20107 21.7366 2.73223 21.2678C2.26339 20.7989 2 20.163 2 19.5V8.25H22V7H2V5.75C2 5.08696 2.26339 4.45107 2.73223 3.98223C3.20107 3.51339 3.83696 3.25 4.5 3.25H5.75V2.625C5.75 2.45924 5.81585 2.30027 5.93306 2.18306C6.05027 2.06585 6.20924 2 6.375 2V2Z",
    fill: "current"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBillingDateIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/billing_date_icon.ef3f68c3.svg";
export { ForwardRef as ReactComponent };